import { FormGroup, RadioGroup } from '@mui/material';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import type { ChangeEvent, VoidFunctionComponent } from 'react';

import Button, { ButtonGroup } from '../../../../../../../../generic/Button';
import { LabeledRadio } from '../../../../../../../../generic/Forms';

import styles from './CustomHeaderModal.module.less';

 enum CustomHeaderActions {
  Propagate = 'propagate',
  DoNotPropagate = 'do-not-propagate',
}
// Eslint doesn't like this "should"
// eslint-disable-next-line @typescript-eslint/naming-convention
const SHOULD_SET_DEFAULT = true;

type Props = {
  shouldShowModal: boolean;
  onHide(): void;
  onSave(shouldSetDefault: boolean, shouldPropagate: boolean): Promise<void>;
};

/**
 * This modal provides an interface to modify custom headers: logo and text
 */
const PropagateHeaderChangesModal: VoidFunctionComponent<Props> = ({ shouldShowModal, onHide, onSave }) => {
  const [shouldPropagate, setShouldPropagate] = useState<boolean>(false);

  // Save functionality
  const handleSave = () => {
    onSave(SHOULD_SET_DEFAULT, shouldPropagate);
    onHide();
  };

  const handlePropagateChange = (_event: ChangeEvent<HTMLInputElement>, updatedAction: string) => {
    setShouldPropagate(CustomHeaderActions.Propagate === updatedAction);
  };

  return (
    <div className={styles.reportCustomHeaderModal}>
      <Modal show={shouldShowModal} onHide={onHide} backdropClassName="modal-nested">
        <Modal.Header closeButton>
          <Modal.Title>Change organization level report settings</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.reportCustomHeaderModal}>
          <FormGroup>
            <RadioGroup
              name="propagateDefaultReportCustomText"
              defaultValue={CustomHeaderActions.DoNotPropagate}
              onChange={handlePropagateChange}
            >
              <LabeledRadio
                label="Make Default"
                value={CustomHeaderActions.DoNotPropagate}
              />

              <LabeledRadio
                label="Propagate to existing projects and make default"
                value={CustomHeaderActions.Propagate}
              />
            </RadioGroup>
          </FormGroup>
          <div>
            {shouldPropagate ? (
              <p>These changes will be propagated to all current projects and release groups in your organization.</p>
            ) : (
              <p>
                All future projects and release groups will be created with these settings.
                Current projects in FOSSA will
                remain unchanged.
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonGroup spacing="xs">
            <Button
              onClick={onHide}
              type="secondary"
              size="medium"
            >
              Cancel
            </Button>
            <div style={{ marginLeft: '5px' }}>
              <Button
                onClick={handleSave}
                type="primary"
                size="medium"
              >
                Confirm
              </Button>
            </div>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PropagateHeaderChangesModal;
